import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BarcodeResult {
  code: string;
  timestamp: Date;
  source: 'scanner' | 'manual';
}

@Injectable({
  providedIn: 'root',
})
export class GlobalScannerService {
  private scannerActiveSubject = new BehaviorSubject<boolean>(false);
  private barcodeScannedSubject = new BehaviorSubject<BarcodeResult | null>(
    null
  );

  public scannerActive$ = this.scannerActiveSubject.asObservable();
  public barcodeScanned$ = this.barcodeScannedSubject.asObservable();

  constructor() {
    this.setupGlobalKeyboardListener();
  }

  private setupGlobalKeyboardListener(): void {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      // Ctrl+S para abrir scanner globalmente
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault();
        this.activateScanner();
      }

      // ESC para fechar scanner
      if (event.key === 'Escape') {
        this.deactivateScanner();
      }
    });
  }

  activateScanner(): void {
    this.scannerActiveSubject.next(true);
  }

  deactivateScanner(): void {
    this.scannerActiveSubject.next(false);
  }

  emitBarcodeScanned(
    code: string,
    source: 'scanner' | 'manual' = 'manual'
  ): void {
    const result: BarcodeResult = {
      code: code.trim(),
      timestamp: new Date(),
      source,
    };

    this.barcodeScannedSubject.next(result);
    this.deactivateScanner();
  }

  isActive(): boolean {
    return this.scannerActiveSubject.value;
  }
}
